const sortCategories = [
  {
    text: 'Population: High to Low',
    id: 'popHL',
  },
  {
    text: 'Population: Low to High',
    id: 'popLH',
  },
  {
    text: 'Name: A to Z',
    id: 'nameAZ',
  },
  {
    text: 'Name: Z to A',
    id: 'nameZA',
  },
  {
    text: 'Area: High to Low',
    id: 'areaHL',
  },
  {
    text: 'Area: Low to High',
    id: 'areaLH',
  },
];

export default sortCategories;
